export const Usvi_Domain =  window.location.origin;
